// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

/** #172: the MapTiler Cloud key for this environment's origin (MapTiler → API keys → allowed origins). */
const MAPTILER_KEY = '';

/** #172: the Google Maps JavaScript API key for this environment's origin (Cloud Console → restricted by HTTP referrer + API). */
const GOOGLE_MAPS_KEY = 'AIzaSyBZRBhd9FsivOaTZ3li78QVGqeY84Rd1EU';
/** #172: a Map ID (Cloud Console → Map Management, free); empty falls back to the classic markers. */
const GOOGLE_MAPS_MAP_ID = 'ba4de35fa9d4c4c03c00b759';

export const environment = {
  production: false,
  test: false,
  dev: true,
  apiUrl: 'https://dev.get-local.net/bff/api',
  identityServerUrl: 'https://dev.get-local.net/idp',
  clientId: 'GetLocal.Client.Spa',
  home_uri: 'https://dev.get-local.net',
  responseType: 'code',
  scope: 'openid profile GetLocal.Api.Bff GetLocal.Api.CatalogSync email address parentsub country',
  // #172: the catalog map. Decided 2026-10-21 for both clients: Google Maps is the DEFAULT
  // provider (free below 10,000 map loads a month, then paid — set a daily quota cap in the
  // Cloud Console), Leaflet + MapTiler raster tiles the configured fallback: switch `provider`
  // to 'leaflet' when the loads outgrow the free tier. Both keys are public by design and
  // origin-restricted in their consoles; without one the map shows pins on a blank background.
  map: {
    provider: 'google' as 'google' | 'leaflet',
    google: { apiKey: GOOGLE_MAPS_KEY, mapId: GOOGLE_MAPS_MAP_ID },
    tiles: {
      urlTemplate: 'https://api.maptiler.com/maps/streets-v2/{z}/{x}/{y}.png?key=' + MAPTILER_KEY,
      attribution: '&copy; <a href="https://www.maptiler.com/copyright/" target="_blank" rel="noopener">MapTiler</a> &copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap contributors</a>',
      maxZoom: 19,
    },
  },
  //clientSecret: 'Secret'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
